import { MonoMenuTopLevelNutritionDetailsSection } from '@/models';
import Vue from 'vue';
import { ui } from '@/constants';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgNutritionCalculatorMealBuilderGraph',
})
export default class CmgNutritionCalculatorMealBuilderGraph extends Vue {
  @Prop({ required: true, type: Object })
  nutrition!: {
    carb: number;
    prot: number;
    tfat: number;
  };

  @Prop({ required: true, type: Boolean }) 
  isExpanded!: boolean;

  get isMobileSafari(): boolean {
    return navigator.userAgent.match(/(iPad|iPhone|iPod)/i) !== null;
  }

  get nutritionPercentages(): {
    carb: number;
    prot: number;
    tfat: number;
  } {
    const total = this.nutrition.carb + this.nutrition.prot + this.nutrition.tfat;

    return {
      carb: this.nutrition.carb / total || 0,
      prot: this.nutrition.prot / total || 0,
      tfat: this.nutrition.tfat / total || 0,
    };
  }

  get protStart(): number {
    return this.nutritionPercentages.carb * 360;
  }

  get fatStart(): number {
    return (this.nutritionPercentages.carb + this.nutritionPercentages.prot) * 360;
  }

  get fatColor(): string {
    return ui.colors.redBurnt;
  }
  get carbColor(): string {
    return ui.colors.yellowCarbs;
  }
  get proteinColor(): string {
    return ui.colors.greenMedium;
  }
}
